export default "__VITE_ASSET__DqBs29sI__"